module.exports = __webpack_public_path__ + "img/AZE.57b25a78.svg";